import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import moment from "moment-timezone";
import DPServices from "@dp/services";
import { ORDER_TYPES, getGUID } from "@dp/common";
import { PaymentFlow } from "./types";
import { v5 as uuidv5 } from "uuid";
var DATE_FORMAT = "MM/DD/YYYY";
/*
findMenuItemAvailibilityFromDayPartInfo funtion will check availbility of
menu items on selected pickup date. This function returning unavailable flag. Accepts 3 parameters productid, dayPartInfo, selectedPickTime.
daypartinfo details we will get 4 types of information of menu item
    1. advanceOrderMessage - unavailable message for menu item
    2. daySelection - the details of on which days a menu item is available and at what time a menu item is available
    3. startDate | endDate -  menu item will available between startDate and endDate
    4. unavailableStartDate | unavailableEndDate -  menu item will unavailable between unavailableStartDate and unavailableStartDate

  To find menu avaibility we need to check all above details considering below conditions for selectedPickUpDate-
    A. checking selected pickup date is between startdate and end date
    B. checking selected pickup date is between unavailableStartDate | unavailableEndDate
    C. checking on selected day menu item is available using day selection details

    if condition (A) and (C) satifies and not (B) then menu item will be available.
    if only daySelection detail available, on (C) satifies menu item will be available.
    if only startDate and endDate detail available, on (A) satifies menu item will be available.
    if only unavailableStartDate and unavailableEndDate detail available, on (B) satifies menu item will be not available.

*/

/*
  - Function used for new cloud changes of Menulist and Menu details
 */

export var findMenuItemAvailibity = function findMenuItemAvailibity(_ref) {
  var dayPartInfo = _ref.dayPartInfo,
      advanceOrdering = _ref.advanceOrdering,
      currentPickupTime = _ref.currentPickupTime;
  /* true => avail, false => unavail */

  var dayPartResult = findMenuAvailabityByDayPart(dayPartInfo, currentPickupTime);
  /* true => avail, false => unavail */

  var advOdAvailDates = findMenuAvailabityByAdvanceOrderingAvailableDates(currentPickupTime, advanceOrdering);
  /* true => avail, false => unavail */

  var advOdUnAvailDates = findMenuAvailabityByAdvanceOrderingUnAvailableDates(currentPickupTime, advanceOrdering);

  if (dayPartResult && advOdAvailDates && advOdUnAvailDates) {
    var _advanceOrdering$;

    return {
      isUnavailable: false,
      unAvailableMessage: (advanceOrdering === null || advanceOrdering === void 0 ? void 0 : (_advanceOrdering$ = advanceOrdering[0]) === null || _advanceOrdering$ === void 0 ? void 0 : _advanceOrdering$.advanceOrderMessage) || ""
    };
  } else {
    var _advanceOrdering$2;

    return {
      isUnavailable: true,
      unAvailableMessage: (advanceOrdering === null || advanceOrdering === void 0 ? void 0 : (_advanceOrdering$2 = advanceOrdering[0]) === null || _advanceOrdering$2 === void 0 ? void 0 : _advanceOrdering$2.advanceOrderMessage) || ""
    };
  }
};
/**
 *
 * If the current pickup time is in between the daypart start and end time, then it is **available**
 */

export var findMenuAvailabityByDayPart = function findMenuAvailabityByDayPart(dayPartInfo, _currentPickupTime) {
  var isAvailable = true;
  var pickupStartTimeMomentObject = moment(_currentPickupTime === null || _currentPickupTime === void 0 ? void 0 : _currentPickupTime.startTimeInMs);
  var dayPartSlotByDayName = dayPartInfo === null || dayPartInfo === void 0 ? void 0 : dayPartInfo.find(function (dp) {
    return (pickupStartTimeMomentObject === null || pickupStartTimeMomentObject === void 0 ? void 0 : pickupStartTimeMomentObject.day()) + 1 === dp.dayName;
  });

  if (dayPartInfo !== null && dayPartInfo !== void 0 && dayPartInfo.length && dayPartSlotByDayName) {
    isAvailable = isDateInBetween(moment(moment(pickupStartTimeMomentObject).format("HH:mm:ss"), "HH:mm:ss"), moment(dayPartSlotByDayName === null || dayPartSlotByDayName === void 0 ? void 0 : dayPartSlotByDayName.startTime, "HH:mm:ss"), moment(dayPartSlotByDayName === null || dayPartSlotByDayName === void 0 ? void 0 : dayPartSlotByDayName.endTime, "HH:mm:ss"));
  }

  return isAvailable;
};
/**
 *
 * If the current pickup time is in between the adv ord start and end date, then it is **available**
 */

export var findMenuAvailabityByAdvanceOrderingAvailableDates = function findMenuAvailabityByAdvanceOrderingAvailableDates(currentPickupTime, advanceOrdering) {
  var selectedTimeInMS = moment(currentPickupTime === null || currentPickupTime === void 0 ? void 0 : currentPickupTime.startTimeInMs).valueOf();
  var advanceOrderingSlot = advanceOrdering === null || advanceOrdering === void 0 ? void 0 : advanceOrdering[0];

  if (!(advanceOrderingSlot !== null && advanceOrderingSlot !== void 0 && advanceOrderingSlot.startDate) || !(advanceOrderingSlot !== null && advanceOrderingSlot !== void 0 && advanceOrderingSlot.endDate)) {
    return true;
  }

  return isDateInBetween(moment(selectedTimeInMS), moment(advanceOrderingSlot === null || advanceOrderingSlot === void 0 ? void 0 : advanceOrderingSlot.startDate), moment(advanceOrderingSlot === null || advanceOrderingSlot === void 0 ? void 0 : advanceOrderingSlot.endDate));
};
/**
 *
 * If the current pickup time is in between the adv ord unAv start and unAv end date, then it is **not available**
 */

export var findMenuAvailabityByAdvanceOrderingUnAvailableDates = function findMenuAvailabityByAdvanceOrderingUnAvailableDates(currentPickupTime, advanceOrdering) {
  var selectedTimeInMS = moment(currentPickupTime === null || currentPickupTime === void 0 ? void 0 : currentPickupTime.startTimeInMs).valueOf();
  var advanceOrderingSlot = advanceOrdering === null || advanceOrdering === void 0 ? void 0 : advanceOrdering[0];

  if (!(advanceOrderingSlot !== null && advanceOrderingSlot !== void 0 && advanceOrderingSlot.unavailableStartDate) || !(advanceOrderingSlot !== null && advanceOrderingSlot !== void 0 && advanceOrderingSlot.unavailableEndDate)) {
    return true;
  } // if in between, then not avaialble. hence the negation.


  return !isDateInBetween(moment(selectedTimeInMS), moment(advanceOrderingSlot === null || advanceOrderingSlot === void 0 ? void 0 : advanceOrderingSlot.unavailableStartDate), moment(advanceOrderingSlot === null || advanceOrderingSlot === void 0 ? void 0 : advanceOrderingSlot.unavailableEndDate));
};

var isDateInBetween = function isDateInBetween(time, startTime, endTime) {
  return time.isBetween(startTime, endTime, undefined, "[]") ? true : false;
}; // To find menu avaibility by day selection details


var _findMenuAvaibilityByDaySelection = function _findMenuAvaibilityByDaySelection(pickupStartTimeMomentObject, productDayPartInfo) {
  var _productDayPartInfo$d;

  var isAvailable = false;

  if (productDayPartInfo !== null && productDayPartInfo !== void 0 && (_productDayPartInfo$d = productDayPartInfo.daysSelection) !== null && _productDayPartInfo$d !== void 0 && _productDayPartInfo$d.length) {
    var _productDayPartInfo$d2;

    var selectedDayTimeInformation = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$d2 = productDayPartInfo.daysSelection) === null || _productDayPartInfo$d2 === void 0 ? void 0 : _productDayPartInfo$d2.find(function (_d) {
      return pickupStartTimeMomentObject.day() + 1 === _d.dayName;
    });

    if (selectedDayTimeInformation) {
      var pickupStartTimeMomentObjectTime = moment(moment(pickupStartTimeMomentObject).format("HH:mm:ss"), "HH:mm:ss");
      isAvailable = isDateInBetween(pickupStartTimeMomentObjectTime, moment(selectedDayTimeInformation === null || selectedDayTimeInformation === void 0 ? void 0 : selectedDayTimeInformation.startTime, "HH:mm:ss"), moment(selectedDayTimeInformation === null || selectedDayTimeInformation === void 0 ? void 0 : selectedDayTimeInformation.endTime, "HH:mm:ss"));
    }
  } else {
    isAvailable = true;
  }

  return isAvailable;
}; // To find menu avaibility by available startdate and enddate details from daypartinfo


var _findMenuAvaibilityByAvailableDates = function _findMenuAvaibilityByAvailableDates(pickupStartTimeMomentObject, productDayPartInfo) {
  var availableStartDate = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : productDayPartInfo.startDate;
  var availableEndDate = productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : productDayPartInfo.endDate;
  return availableStartDate && availableEndDate ? isDateInBetween(pickupStartTimeMomentObject, moment(availableStartDate === null || availableStartDate === void 0 ? void 0 : availableStartDate.time), moment(availableEndDate === null || availableEndDate === void 0 ? void 0 : availableEndDate.time)) : true;
}; // To find menu avaibility by unavailable startdate and enddate details from daypartinfo


var _findMenuAvaibilityByUnAvailableDates = function _findMenuAvaibilityByUnAvailableDates(pickupStartTimeMomentObject, productDayPartInfo) {
  var _productDayPartInfo$u, _productDayPartInfo$u2;

  return productDayPartInfo !== null && productDayPartInfo !== void 0 && productDayPartInfo.unavailableStartDate && productDayPartInfo !== null && productDayPartInfo !== void 0 && productDayPartInfo.unavailableEndDate ? !isDateInBetween(pickupStartTimeMomentObject, moment(productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$u = productDayPartInfo.unavailableStartDate) === null || _productDayPartInfo$u === void 0 ? void 0 : _productDayPartInfo$u.time), moment(productDayPartInfo === null || productDayPartInfo === void 0 ? void 0 : (_productDayPartInfo$u2 = productDayPartInfo.unavailableEndDate) === null || _productDayPartInfo$u2 === void 0 ? void 0 : _productDayPartInfo$u2.time)) : true;
};

export var _getFormattedDate = function _getFormattedDate(time) {
  var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var today = moment();
  var tomorrow = moment().add(1, "days");
  var date = moment(time);
  if (date.isSame(today, "d")) return date.format("[Today], MMM Do" + (includeTime ? ", hh:mm a" : ""));else if (date.isSame(tomorrow, "d")) return date.format("[Tomorrow], MMM Do" + (includeTime ? ", hh:mm a" : ""));else {
    if (includeTime) {
      return date.format("MMM Do, hh:mm a");
    } else {
      return date.format(DATE_FORMAT);
    }
  }
};
export var fetchDistances = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(myCoords, restSearchResults) {
    var resultObj, resultsLength, start, end, noOfCall, i, obj;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            resultObj = {};
            resultsLength = restSearchResults.length;
            noOfCall = Math.ceil(resultsLength / 24);
            i = 0;

          case 5:
            if (!(noOfCall > i)) {
              _context.next = 15;
              break;
            }

            start = 24 * i;
            end = resultsLength < 24 * (i + 1) ? resultsLength : 24 * (i + 1);
            _context.next = 10;
            return fetchDistancesAPI(myCoords, restSearchResults.slice(start, end));

          case 10:
            obj = _context.sent;
            resultObj = _objectSpread(_objectSpread({}, resultObj), obj);
            i++;
            _context.next = 5;
            break;

          case 15:
            return _context.abrupt("return", resultObj);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {});

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }));

  return function fetchDistances(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchDistancesAPI = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(myCoords, restSearchResults) {
    var tempApiStr, tempCurbStr, resultObj, distanceResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            tempApiStr = "";
            tempCurbStr = "curb;";
            resultObj = {};
            tempApiStr += myCoords.longitude.toString() + "," + myCoords.latitude.toString() + ";";
            restSearchResults === null || restSearchResults === void 0 ? void 0 : restSearchResults.forEach(function (data, idx) {
              tempApiStr += data.contactDetail.address.coordinates.longitude.toString() + "," + data.contactDetail.address.coordinates.latitude.toString();
              tempCurbStr = tempCurbStr + "curb";

              if (idx !== restSearchResults.length - 1) {
                tempApiStr += ";";
                tempCurbStr += ";";
              }
            });
            _context2.next = 8;
            return DPServices.Location.getRestaurantDistance(tempApiStr, tempCurbStr);

          case 8:
            distanceResult = _context2.sent;
            distanceResult === null || distanceResult === void 0 ? void 0 : distanceResult.forEach(function (data, idx) {
              if (idx > 0) {
                var _key = restSearchResults[idx - 1].restaurantNumber;
                var distInKms = data / 1000;
                var distInMiles = distInKms * 0.621371; // initate distance to large value.

                var distance = 9999; // if api retuns valid number, do the calculation, else consider distance to higher value
                // if floor of distance=0, we return -1 which is used in computautions in the UI. else return floor value

                if (data !== null && data !== undefined) {
                  if (Math.floor(distInMiles)) {
                    distance = Math.floor(distInMiles);
                  } else {
                    distance = -1;
                  }
                }

                resultObj[_key] = distance;
              }
            });
            return _context2.abrupt("return", resultObj);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", {});

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 13]]);
  }));

  return function fetchDistancesAPI(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var fetchDistanceFromRestuarant = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(myCoords, restaurantDetails) {
    var _restaurantDetails$co, _restaurantDetails$co2, tempApiStr, tempCurbStr, mapAttributes, latitude, longitude, resultObj, distanceResult;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            tempApiStr = "";
            tempCurbStr = "curb;";
            mapAttributes = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$co = restaurantDetails.contactDetail) === null || _restaurantDetails$co === void 0 ? void 0 : (_restaurantDetails$co2 = _restaurantDetails$co.address) === null || _restaurantDetails$co2 === void 0 ? void 0 : _restaurantDetails$co2.coordinates;
            latitude = mapAttributes === null || mapAttributes === void 0 ? void 0 : mapAttributes.latitude;
            longitude = mapAttributes === null || mapAttributes === void 0 ? void 0 : mapAttributes.longitude;
            resultObj = {};
            tempApiStr += myCoords.longitude.toString() + "," + myCoords.latitude.toString() + ";";
            tempApiStr += longitude.toString().trim() + "," + latitude.toString();
            _context3.next = 11;
            return DPServices.Location.getRestaurantDistance(tempApiStr, tempCurbStr);

          case 11:
            distanceResult = _context3.sent;
            distanceResult === null || distanceResult === void 0 ? void 0 : distanceResult.forEach(function (data, idx) {
              if (idx > 0) {
                var _key2 = restaurantDetails.atgRestaurantId;
                var distInKms = data / 1000;
                var distInMiles = distInKms * 0.621371;
                console.log("current location distinMiles,", distInMiles);
                resultObj[_key2] = distInMiles;
              }
            });
            return _context3.abrupt("return", resultObj);

          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", {});

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 16]]);
  }));

  return function fetchDistanceFromRestuarant(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var decodeIsAlcohol = function decodeIsAlcohol(isAlcohol, restaurantDetails, alcoholSubClassification, orderType) {
  var isPickupOrder = orderType === ORDER_TYPES.TOGO_PICKUP || orderType === ORDER_TYPES.CATERING_PICKUP;
  var isDeliveryOrder = orderType === ORDER_TYPES.CATERING_DELIVERY;
  var result = false;
  var toolTipMessage = "";

  if (isAlcohol) {
    if (isPickupOrder) {
      toolTipMessage = "DINE IN ONLY";

      switch (alcoholSubClassification) {
        case "LIQUOR":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isLiquorAllowedForToGo;
          break;

        case "BEER":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isBeerAllowedForToGo;
          break;

        case "WINE":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isWineAllowedForToGo;
          break;

        case undefined:
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForToGo;
      }
    }

    if (isDeliveryOrder) {
      toolTipMessage = "Sorry, this location do not deliver alcohol items";

      switch (alcoholSubClassification) {
        case "LIQUOR":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isLiquorAllowedForDelivery;
          break;

        case "BEER":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isBeerAllowedForDelivery;
          break;

        case "WINE":
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isWineAllowedForDelivery;
          break;

        case undefined:
          result = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.isAlcoholAllowedForDelivery;
      }
    }

    if (!result) {
      return {
        isAlcohol: true,
        toolTipMessage: toolTipMessage
      };
    }
  }

  return {
    isAlcohol: false,
    toolTipMessage: toolTipMessage
  };
};
export var decodeIsAdvanceOrderingProduct = function decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage, isAdvanceOrderingAllowed) {
  return isUnavailable && unAvailableMessage && (unAvailableMessage === null || unAvailableMessage === void 0 ? void 0 : unAvailableMessage.length) && isAdvanceOrderingAllowed === "true";
};
export var getDialogueCode = function getDialogueCode(props) {
  var platformCode = props.isPlatformMobileApp ? "1" : "2";

  var paymentFlowCode = function () {
    var orderFlow = null;

    if (props.paymentFlow === PaymentFlow.CHECKOUT) {
      orderFlow = "14";
    } else if (props.paymentFlow === PaymentFlow.GC_CHECKOUT) {
      orderFlow = "3";
    } else {
      orderFlow = "2";
    }

    if (orderFlow === "2") {
      switch (props.paymentFlow) {
        case PaymentFlow.MPAY_CLQ:
          return orderFlow.concat("1");

        case PaymentFlow.MPAY_TLQ:
          return orderFlow.concat("2");

        case PaymentFlow.MPAY_OPCIO:
          return orderFlow.concat("3");

        default:
          return orderFlow.concat("");
      }
    }

    return orderFlow;
  }();

  return "".concat(platformCode, paymentFlowCode, props.errorCodeToAppend);
};
export var getUniqueSessionID = function getUniqueSessionID(brand) {
  try {
    return uuidv5(brand, getGUID()).replace(/-/g, "").substring(0, 16);
  } catch (error) {
    return null;
  }
}; //

export var formatPriceOC = function formatPriceOC(price, pricingFormat) {
  switch (pricingFormat) {
    case "$xx":
      return "$".concat(Number(price.toFixed(2)));

    case "$xx.xx":
      return "$".concat(price.toFixed(2));

    case "xx":
      return "".concat(price.toFixed(2));

    case "xx.xx":
      return "".concat(price.toFixed(2));

    case "s52":
      return "".concat(Number(price.toFixed(2)));

    default:
      return "$".concat(Number(price.toFixed(2)));
  }
};
/**
 *
 * @param {OrderTypes.IQuoteResponse} quote Quote object
 * @returns {{ minTime: number; maxTime: number }} Returns an object with `minTime` and `maxTime` in `numbers`
 */

export var getMinMaxQuotes = function getMinMaxQuotes(quote) {
  var quoteCreatedAt = moment(quote.created);
  var dropOffEta = moment(quote.dropOffEta);
  var dropOffDeadline = moment(quote.dropOffDeadline);
  var etaDiff = dropOffEta.diff(quoteCreatedAt, "minutes");
  var deadlineDiff = dropOffDeadline.diff(quoteCreatedAt, "minutes");
  var minTime = Math.ceil(etaDiff / 5) * 5;
  var maxTime = Math.ceil(deadlineDiff / 5) * 5;
  return {
    minTime: minTime,
    maxTime: maxTime
  };
};
/**
 *
 * @param {OrderTypes.IQuoteResponse} previousQuote An object containing previous quote
 * @param {OrderTypes.IQuoteResponse} updatedQuote An object containing updated quote
 * @returns {boolean} Returns `true` if there is a change in either the ETA or deadline times, `false` otherwise.
 */

export var hasDeliveryTimeChanged = function hasDeliveryTimeChanged(previousQuote, updatedQuote) {
  var prevMinMaxTime = getMinMaxQuotes(previousQuote);
  var updatedMinMaxTime = getMinMaxQuotes(updatedQuote);
  return prevMinMaxTime.minTime !== updatedMinMaxTime.minTime || prevMinMaxTime.maxTime !== updatedMinMaxTime.maxTime;
};